'use strict';

var player,
       APIModules,
       videoPlayer,
       experienceModule;


function selectRendition(context) {
  var renditions = context.renditions;
  var renditionIndex = -1;
  var size = 0;
  for (var i = 0; i < renditions.length; i++) {
    // set the rendition index for the rendition with the largest size
    if (renditions[i].size > size) {
      size = renditions[i].size;
      renditionIndex = i;
    }
  }
  return renditionIndex;
}

//var myTemplateLoaded = function (experienceID) {
//  player = brightcove.api.getExperience(experienceID);
//  
//  modVP = player.getModule(brightcove.api.modules.APIModules.VIDEO_PLAYER);
//  modExp = player.getModule(brightcove.api.modules.APIModules.EXPERIENCE);
//  modCon = player.getModule(brightcove.api.modules.APIModules.CONTENT);
//};

function onTemplateLoad(experienceID) {
  if (bcNwnssA && bcNwnssA.adways) {
    new adways.brightcove.Loader({ 
      'experienceID': experienceID, 
      projectID: bcNwnssA.adways,
      'popupBackground': {
        'color': { 
          'r': 233, 
          'g': 205, 
          'b': 208 
        },
        'opacity': 0.8,
        'animationDuration': 500
      } 
    }); 
  }
  player = brightcove.api.getExperience(experienceID);
  APIModules = brightcove.api.modules.APIModules;
  videoPlayer = player.getModule(APIModules.VIDEO_PLAYER);
  if (videoPlayer && videoPlayer.hasOwnProperty('setRenditionSelectionCallback')) {
    videoPlayer.setRenditionSelectionCallback(selectRendition);
  }
  videoPlayer.addEventListener(brightcove.api.events.MediaEvent.RENDITION_CHANGE_REQUEST, function (event) {
  });
}

function onTemplateReady(evt) {
//  videoPlayer = player.getModule(APIModules.VIDEO_PLAYER);
  experienceModule = player.getModule(APIModules.EXPERIENCE);
  videoPlayer.addEventListener(brightcove.api.events.MediaEvent.COMPLETE, function (event) {
   onComplete(event);
  });
  videoPlayer.addEventListener(brightcove.api.events.MediaEvent.PROGRESS, function (event) {
   onMediaProgressFired(event);
  });
 
  videoPlayer.getCurrentRendition(function(renditionDTO) {
    if (renditionDTO) {
      calulateNewPercentage(renditionDTO.frameWidth, renditionDTO.frameHeight);
    } else {
      videoPlayer.addEventListener(brightcove.api.events.MediaEvent.PLAY, function(event) {
        calulateNewPercentage(event.media.renditions[0].frameWidth, event.media.renditions[0].frameHeight);	 
      });
    }
  });

  var evt = document.createEvent('UIEvents');
  evt.initUIEvent('resize',true,false,0);
  window.dispatchEvent(evt);
  
  videoPlayer.play();

}

function calulateNewPercentage(width,height) {
  var newPercentage = ((height / width) * 100) + "%";
  document.getElementById("container1").style.paddingBottom = newPercentage;
}

document.addEventListener('playerOrPageSizeChange', function (e) {
  var resizeWidth = $(".BrightcoveExperienceMainPlayer").width(),
      resizeHeight = $(".BrightcoveExperienceMainPlayer").height();
  if (experienceModule && experienceModule.experience.type == "html"){
    experienceModule.setSize(resizeWidth, resizeHeight)
  }
  
  
});

document.addEventListener('orientationchange', function (e) {
  function iOSversion() {
    if (/iP(hone|od|ad)/.test(navigator.platform)) {
      // supports iOS 2.0 and later: <http://bit.ly/TJjs1V>
      var v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
      return [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || 0, 10)];
    } else if (/Version\/5\..*Safari/.test(navigator.userAgent)) {
      return true;
    }
  }
  var ver = iOSversion();
//  if (ver && ver[0] === 6) {
  if (ver) {
    $('iframe#myExperience').height($('iframe#myExperience').parent().height());
    $('iframe#myExperience').width($('iframe#myExperience').parent().width());
  }
  
  var myRatio = $('#container1').height() / $('#container1').width();
  if (ver && $(window).width > 600) {
    // iOS fix only
    var newWidth = $(window).width() - 80;
  } else {
    var newWidth = $(window).width();
  }
  var newHeight = newWidth * myRatio;
  if (experienceModule && experienceModule.experience.type == "html"){
    experienceModule.setSize(newWidth, newHeight);
  }

});

// BrightCove too, huh
function onMediaProgressFired(data) {
  
  var counter = Math.floor(data.duration - data.position);
  if (counter < 0) {
    counter = 0;
  }

  var event = document.createEvent('CustomEvent');
  event.initCustomEvent('digestListenerOnMediaProgressFired', true, true, counter);

  setTimeout(function () {
    document.dispatchEvent(event);
    // below moved to digestListener
    // angular.element('html').scope().$root.$apply(function () {
    //   angular.element('html').scope().$root.localPlaylist.updateCounter(counter);
    // });
  });
  
}

function onComplete(data) {
  var event = document.createEvent('Event');
  event.initEvent('digestListenerOnComplete', true, true);
  document.dispatchEvent(event);
}



//////////////////
// WEBPACK FOOTER
// ./assets/vendor/js/mikesCode.js
// module id = 1155
// module chunks = 0